import Hallazgos from './Hallazgos';
import apiService from '../services/apiService';

/**
 * Vista filtrada de hallazgos propios del usuario (abiertos, sin OT)
 *
 * @returns {JSX.Element}
 */
function MisHallazgos() {
  return <Hallazgos fetchFn={apiService.getMisHallazgos} pageTitle="Mis Hallazgos" exportName="Mis_Hallazgos" hideManagement />;
}

export default MisHallazgos;
